export default __webpack_public_path__ + "static/media/watch-icon.d297f2b2.svg";